// src/components/pages/Produto/boot/fileAssets.js

/**
 * Contrato padrão de "asset local" (arquivo ainda não salvo no banco):
 * - tempId: identificador local
 * - file: File original (para upload via FormData)
 * - previewUrl: URL blob: criada por URL.createObjectURL(file)
 * - descricao: nome exibido (pode ser editável)
 * - ativo/posicao: metadados opcionais (úteis pra imagens do inventário)
 */

export function makeTempId() {
    // crypto.randomUUID é ótimo, mas pode não existir em browsers mais antigos
    return crypto?.randomUUID?.() || `tmp_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function fileToAsset(file, extra = {}) {
    return {
        tempId: makeTempId(),
        file,
        previewUrl: URL.createObjectURL(file),
        descricao: file?.name || 'arquivo',
        ativo: true,
        ...extra, // ex: { posicao: 'Padrão' }
    };
}

export function revokeAsset(asset) {
    try {
        if (asset?.previewUrl) URL.revokeObjectURL(asset.previewUrl);
    } catch {
        // evita quebrar UI em caso de URL inválida
    }
}

export function revokeAssets(list) {
    (list || []).forEach(revokeAsset);
}

/**
 * Helper para append de arquivos em FormData a partir de uma lista de assets.
 * - fieldName: nome do campo no FormData (ex: "imagens" ou "nfs")
 */
export function appendAssetsToFormData(fd, fieldName, assets) {
    (assets || []).forEach((a) => {
        if (a?.file) fd.append(fieldName, a.file);
    });
}
